<template>
    <div class="target-share">
        <div style="width: 50%; margin-left: auto; margin-right: auto">
            <div class="headerShare">
                <div class="titleHeaderShare">
                    <img src="@/assets/image/ic_gift.png" alt=""/>
                    <h6>{{language.lang('Get free credit by sending a referral code to your friends and colleagues')}}
                    </h6>
                </div>
            </div>
            <v-card style="height: auto" v-if="share != null">
                <div class="socials" style="height: 100%">
                    <div>
                        <div class="btnShare rtl " style="text-align: right">
                            <p style="padding: 20px; padding-bottom: 0; text-align: justify; direction: rtl">
                                {{share}}</p>
                            <base-button text-color="white" dir="ltr" icon="fa fa-share-alt" class="btnmagnum"
                                         color="#4781c6" @click="copyShareText">
                                {{language.lang('Share and receive bonus')}}
                            </base-button>
                        </div>
                    </div>
                </div>
            </v-card>
            <v-card class="itemsShare" v-if="invite != null">
                <ul>
                    <li>
                        <span style="color: darkgray">{{language.lang('Number of invitations')}}</span>
                        <span style="font-weight: bold">{{ invite.user_invites }}</span>
                    </li>
                    <li>
                        <span style="color: darkgray">{{language.lang('Invitation used')}}</span>
                        <span style="font-weight: bold">{{ invite.user_invite_score }}</span>
                    </li>
                    <li>
                        <span style="color: darkgray">{{language.lang('Credits earned')}}</span>
                        <span style="font-weight: bold">{{ invite.user_invite_wallet }}<span
                                style="color: #515151; margin-right: 5px; margin-left: 5px">{{language.lang('Toman')}}</span></span>
                    </li>
                </ul>
            </v-card>
        </div>

    </div>
</template>

<script>
    import oracle from "@/utils/oracle";
    import language from "@/utils/language";

    export default {
        name: "Share",
        data() {
            return {
                invite: null,
                share: null,
                language: language,
                oracle: oracle,
                isEN: oracle.isEN()
            };
        },
        methods: {
            copyShareText() {
                let textArea = document.createElement("textarea");
                textArea.value = this.share + this.invite.user_share_id;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("Copy");
                textArea.remove();
                oracle.showMessage(language.lang('Share message has been saved in your clipboard, share it with family and friends to get a bonus.'))
            }
        },
        mounted() {
            oracle.axios("user/getProfile", {}, (res) => {
                this.invite = res.data
            });
            oracle.axios(
                "setting/getInfo",
                {"filter_by": this.oracle.isEN() ? 'website_en' : 'website', 'search_by': 'share'},
                (res) => {
                    this.share = res.data;
                });
        }
    };
</script>
<style>
    .target-share {
        height: auto;
        text-align: center;
        width: 100%;
    }

    .target-share .headerShare {
        align-items: center;
        margin-bottom: 70px;
    }

    .target-share .btnShare {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

    .target-share .btnShare textarea {
        height: 100px;
        width: 100%;
        resize: none;
        text-align: center;
        font-size: 12px;
    }

    .target-share .btnShare .v-btn {
        color: #fff !important;
        margin: 2rem 0;
    }

    .target-share .titleHeaderShare {
        height: 140px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        margin-bottom: 2.5em;
        margin-top: 20px;
    }

    .target-share .titleHeaderShare img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .target-share .titleHeaderShare h6 {
        font-size: 15px;
        color: #000000;
        text-align: center;
        font-weight: normal;
        width: 100%;
        padding: 10px 15px;
        border-bottom: 1px solid #fff;
    }

    .target-share .imagesocial {
        width: 40px;
        height: 40px;
        border-radius: 50px;
        overflow: hidden;
    }

    .target-share .imagesocial img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .target-share .socials {
        width: 100%;
    }

    .target-share .itemSocial a span {
        font-size: 10px;
        color: #707070;
        padding-top: 10px;
        font-weight: bold;
        text-align: center;
    }

    .target-share .itemSocial a {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .target-share .v-card,
    .target-share .itemsShare {
        margin: 10px 30px;
    }

    .target-share .v-card .socials {
        height: 190px;
        overflow: auto;
        padding: 0 15px;
    }

    .target-share .v-application ul {
        padding-left: 0 !important;
    }

    .target-share .itemsShare ul li {
        border-bottom: 1px solid #707070;
        padding: 15px 10px;
        display: flex;
        font-size: 15px;
        color: #000;
        text-align: center;
        font-weight: bold;
        justify-content: space-between;
    }

    .target-share .itemsShare ul li span {
        color: #4781c6;
        font-size: 15px;
    }

    .target-share .v-card ul li:last-child {
        border: none;
    }

    .target-share .itemsShare {
        border-radius: 10px;
    }

    .target-share .btnmagnum {
        margin-top: 0;
        margin-bottom: 10px;
    }
</style>
